<template>
  <div class="portfolio">
    <form v-on:submit="addItem">
      <input class="text" type="text" v-model="newItem.name" placeholder="Enter Item">
      <input class="desc" type="text" v-model="newItem.description" placeholder="Enter Description">
      <input id="enter" type="submit" value="Submit"/>
    </form>
    <ul id="arrayData">
      <li v-for="items in items">
        <div class="card">
          <h2>{{items.name}}</h2>
          <p>{{items.description}}</p>
          <button v-on:click="deleteItem(user)">Delete Item</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'portfolio',
  data(){
    return{
      newItem: {},
      items: [
        {
          name: 'C#',
          description: 'C# is a Genaral-purpose object oriented programing language.'
        },
        {
          name: 'HTML5',
          description: 'HTML 5 is a markup language used for websites. It is being used to display this webpage.'

        },
        {
          name: 'Vue.js',
          description: 'Vue.js is a javascript framework mainly for displaying user interfaces. It is being used to display this webpage.'
        } 
      ]
    }
  },
  methods: {
    addItem: function(e){
      this.items.push({
        name: this.newItem.name,
        description: this.newItem.description,
      })
      e.preventDefault();
    },
    deleteItem: function(item){
      this.items.splice(this.items.indexOf(item), 1);
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#portfolio{
  margin: auto;
}
#enter{
  display: block;
  margin: auto;
}
.text{
  margin-left: 10px;
  margin-bottom: 10px;
}
.desc{
  width: 500px;
  max-width: 60%;
}
.card{
  border: 2px solid black;

}
ul {
  list-style-type: none;
}
li {
  margin-bottom: 15px;
}
#arrayData{
  padding-left: 0px; 
}

</style>
